interface MobileAuthSession {
  authenticated: boolean;
  token: string;
  refreshToken: string;
  client?: string;
  serverUrl?: string;
}

interface MobileAuthPlugin {
  isAvailable?: () => Promise<{ available: boolean }>;
  getSession: (options: { serverUrl: string }) => Promise<MobileAuthSession>;
  login: (options: { serverUrl: string }) => Promise<MobileAuthSession>;
  refresh?: (options: { serverUrl: string; client?: string }) => Promise<MobileAuthSession>;
  logout?: (options?: { serverUrl?: string }) => Promise<void>;
  clearSession?: () => Promise<void>;
}

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
      Plugins?: {
        MobileAuth?: MobileAuthPlugin;
      };
    };
  }
}

export const getNativeServerUrl = () => window.location.origin;

export const getMobileAuthPlugin = () => window.Capacitor?.Plugins?.MobileAuth;

export const isNativeMobileAuthAvailable = () => {
  const plugin = getMobileAuthPlugin();
  return Boolean(plugin && window.Capacitor?.isNativePlatform?.());
};

export const persistNativeSession = (session: MobileAuthSession) => {
  if (!session.authenticated || !session.token) {
    return false;
  }
  localStorage.setItem('token', session.token);
  return true;
};

export type { MobileAuthPlugin, MobileAuthSession };
